// extracted by mini-css-extract-plugin
export default {"continue":"kj-z"};